import classNames from 'classnames'

import { PLTypedWidgetProps } from '@src/components/pl-base-widget'
import stylesV2 from '@src/quince-site-pdp/src/organisms/productPageSections/brandComparison/brandComparisionV2.module.scss'

import { usePdpSectionImpressionRef } from '../use-ia-impression'

import { isProductDogFood, shouldShowPricePerUnit } from './brand-comparison-widget.helper'
import ProductPriceComparision from './components/product-price-comparison'
import { useBrandComparisonData } from './use-brand-comparison-data'

import type { BrandComparisonWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

// Telemetry action id (session-stream `entity_id`) — a stable identifier, not user-facing copy.
const BRAND_COMPARISON_ACTION = 'brand_comparision'

/**
 * Legacy BRAND_COMPARISON render — the SCSS `ProductPriceComparision` "Beyond compare" table.
 * Served whenever the design system is disabled. Renders nothing until the buy box publishes a
 * resolved variant/price (and whenever there are no on-site competitor brands).
 */
export function BrandComparisonWidgetLegacy(props: PLTypedWidgetProps<BrandComparisonWidgetData>) {
  // IA-only `brand_comparision` impression on scroll-into-view — mirrors the non-PL BrandComparisonProduct
  // section (`entity_id: brand_comparision`, `event_type: is_visible`, context `{ productId, selectedColor }`).
  // Non-PL fires this from a single component that toggles DS/legacy on one div+ref; PL splits that into two
  // widgets and renders only one at runtime, so the same impression lives here + in the DS variant.
  const impressionRef = usePdpSectionImpressionRef({
    action: BRAND_COMPARISON_ACTION,
  })

  const model = useBrandComparisonData(props)
  if (!model) return null

  const { data, derived, brands, quincePrice, giftCardInformation } = model

  return (
    <div className={classNames(stylesV2.brandComparison)} ref={impressionRef}>
      <ProductPriceComparision
        quincePrice={quincePrice}
        productComparisionsBrands={brands}
        hideFreeReturns={data?.hideFreeReturns}
        hasRestockingFee={data?.hasRestockingFee}
        showDollarComparisonPrice={false}
        showGiftCardCredit={derived?.giftCardSupported}
        giftCardInformation={giftCardInformation}
        servings={derived?.servings}
        pricePerServing={derived?.pricePerServing}
        hideSavings={data?.hideSavings}
        isDogFood={isProductDogFood(data?.classification)}
        showPricePerUnit={shouldShowPricePerUnit(data?.classification)}
      />
    </div>
  )
}
